import * as React from "react";
import { forwardRef } from "react";
const SvgTickMarkBaseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.6775 1.42188L3.83333 5.26604L2.3225 3.76104L1.5 4.58354L3.83333 6.91688L8.5 2.25021L7.6775 1.42188Z", fill: "currentColor", stroke: "currentColor" }));
const ForwardRef = forwardRef(SvgTickMarkBaseIcon);
export { ForwardRef as ReactComponent };
